export default "__VITE_ASSET__oK6Diuue__"